import styled from 'styled-components';

import { BottomSheet } from '@xing-com/bottom-sheet';
import { useBreakpoints } from '@xing-com/crate-jobs-hooks';
import { PopUpWindow } from '@xing-com/pop-up-window';
import { spaceXL, spaceXXL } from '@xing-com/tokens';

type Props = {
  className?: string;
  show: boolean;
  onCancel: () => void;
  children: React.ReactNode;
  showCloseButton?: boolean;
  testId?: string;
};

const MobileWrapper = styled.div`
  padding: ${spaceXL};
`;

const StyledPopUp = styled(PopUpWindow)`
  & > div {
    width: 600px;
    padding: ${spaceXXL};
  }
`;

const OverflowWrapper = styled.div`
  overflow-y: auto;
`;

export const PopUp: React.FC<Props> = ({
  className,
  show,
  onCancel,
  children,
  showCloseButton = false,
  testId,
}) => {
  const { isMediaSmallOrTiny } = useBreakpoints();

  return isMediaSmallOrTiny ? (
    <BottomSheet
      className={className}
      show={show}
      onOutsideClick={onCancel}
      showCloseButton={showCloseButton}
      data-testid={testId}
    >
      <MobileWrapper>{children}</MobileWrapper>
    </BottomSheet>
  ) : (
    <StyledPopUp
      isShown={show}
      hide={onCancel}
      onDimmerClick={onCancel}
      data-testid={testId}
    >
      <OverflowWrapper>{children}</OverflowWrapper>
    </StyledPopUp>
  );
};
